import React from 'react';
import { ChevronLeft, Menu } from 'lucide-react';
interface HeaderProps {
  onBack: () => void;
  showBack: boolean;
}
export function Header({
  onBack,
  showBack
}: HeaderProps) {
  return <header className="flex items-center justify-between px-6 py-4 w-full max-w-4xl mx-auto text-[#2d5f5d] relative z-10" data-id="element-15">
      <div className="w-10 h-10 flex items-center justify-center" data-id="element-16">
        {showBack && <button onClick={onBack} className="p-2 hover:bg-[#d4af37]/20 rounded-full transition-colors" aria-label="Go back" data-id="element-17">
            <ChevronLeft className="w-6 h-6" data-id="element-18" />
          </button>}
      </div>

      <div className="flex flex-col items-center" data-id="element-19">
        <img src="https://cdn.magicpatterns.com/uploads/fzAbQzoCuk1G4rnfHiG9rj/CP_long_with_tag.png" alt="California Psychics - The Joy of Certainty" className="h-12 w-auto" data-id="element-20" />
      </div>

      <div className="w-10 h-10 flex items-center justify-center" data-id="element-21">
        <button className="p-2 hover:bg-[#d4af37]/20 rounded-full transition-colors" aria-label="Menu" data-id="element-22"></button>
      </div>
    </header>;
}